// @flow

import { type AppValues } from '@tectonics/app-values';
import { getCountry, type IncomingPayment } from '@tectonics/prs/incoming-payment';
import { type UserInputValues } from '@tectonics/prs/user-input-values';
import { type OutgoingPayment } from '../types';
import { createOutgoingPaymentMappers }  from './factory';

export async function mapOutgoingPayment(
  incomingPayment: IncomingPayment,
  userInputValues: UserInputValues,
  appValues: AppValues,
): Promise<OutgoingPayment> {

  const mappers = createOutgoingPaymentMappers(userInputValues, getCountry(incomingPayment));
  let outgoingPayment: OutgoingPayment = {};

  for (const mapper of mappers) {
    outgoingPayment = {
      ...outgoingPayment,
      ...(await mapper(userInputValues, incomingPayment, appValues, outgoingPayment)),
    };
  }

  return outgoingPayment;

}
